<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="dialogRef.close()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4>Job Logs &mdash; {{ data.name }}</h4>
</div>

<mat-dialog-content>
  <pre style="font-family: 'Courier New', Courier, monospace; font-size: 12px; line-height: 1.6; white-space: pre-wrap; word-break: break-all; background: #1e1e1e; color: #d4d4d4; padding: 16px; border-radius: 4px; max-height: 450px; overflow-y: auto; margin: 0;">{{ data.logs || 'No logs available.' }}</pre>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Close</button>
</mat-dialog-actions>
